import EFPicture from 'elem/compCommon/EFPicture';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import { subscribeShopify } from '@/service';
import moment from 'moment';

export default function A() {
    const { useLang, useState, useRouter, gtm } = useGlobal();
    const { t } = useLang('RV');
    const { locale, query } = useRouter();
    const [msg, setMsg] = useState('');
    const EU_SITES = ['eu', 'uk', 'de', 'fr', 'it', 'es'];
    const [check, setCheck] = useState(![...EU_SITES, 'kr'].includes(locale));
    const [input, setInput] = useState('');
    const nowTime = query?.timer ? new Date(`${query?.timer} GMT+8`).getTime() : new Date().getTime();
    const LaunchTime_AU = new Date('2024/06/10 10:00:00 GMT+8').getTime();
    const AU_ENTER_LAUNCH_FLAG = nowTime >= LaunchTime_AU;
    const US_ACTIVITY_PERIOD = {
        start: new Date('2024/07/22 12:00:00 GMT+8').getTime(),
        end: new Date('2024/08/02 12:00:00 GMT+8').getTime(),
    };

    const handleCheck = () => {
        setCheck(!check);
        setMsg(check ? t('A_check_tip') : '');
    };

    const handleInputChange = (v: any) => {
        setInput(v.target.value);
        if (msg && check) {
            setMsg('');
        }
    };

    const handleFocus = () => {
        if (msg && check) {
            setMsg('');
        }
    };

    const IMG_MAP: any = {
        us: {
            pc: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717074522595/1.jpg',
            h5: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717074362916/1_M.jpg',
            pc_1: 'https://websiteoss.ecoflow.com/upload/image/1721617586510/%E5%AE%98%E7%BD%91banner%E5%B0%BA%E5%AF%B8PC%20-.jpg',
            h5_1: 'https://websiteoss.ecoflow.com/upload/image/1721617597707/%E5%AE%98%E7%BD%91banner%E5%B0%BA%E5%AF%B8M%20-.jpg',
        },
        eu: {
            pc: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717074611684/1.jpg',
            h5: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717074629052/1_M.jpg',
        },
        au: {
            pc: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717074563086/1.jpg',
            h5: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717074578264/1_M.jpg',
        },
    };

    const CONTACT_LIST_ID_MAP: any = {
        us: '1487185288',
        ca: '1487185288',
        au: '1208097006',
        eu: '1750923733',
        uk: '1750923733',
        de: '1750923733',
        fr: '1750923733',
        it: '1750923733',
        es: '1750923733',
        kr: '815956244',
    };
    const { getSystemTime } = useGlobal();
    const systemTime = getSystemTime();
    const date = moment(systemTime).format('YYYY-MM-DD') as any;
    const FIELDS_MAP: any = {
        us: [
            {
                id: '4423',
                type: 'single',
                value: 1,
                overwrite: true,
            },
            {
                id: '31',
                type: 'single',
                value: 1,
                overwrite: false,
            },
            {
                id: '9435',
                type: 'multiple',
                value: [23],
                overwrite: false,
            },
            { type: 'text', id: '9625', value: date, overwrite: false },
        ],
        ca: [
            {
                id: '4424',
                type: 'single',
                value: 1,
                overwrite: true,
            },
            {
                id: '31',
                type: 'single',
                value: 1,
                overwrite: false,
            },
            {
                id: '9435',
                type: 'multiple',
                value: [23],
                overwrite: false,
            },
            { type: 'text', id: '9626', value: date, overwrite: false },
        ],
        au: [
            {
                id: '10539',
                type: 'single',
                value: 1,
                overwrite: true,
            },
        ],
        eu: [
            {
                id: '9690',
                type: 'multiple',
                value: [10],
                overwrite: false,
            },
        ],
        uk: [
            {
                id: '9690',
                type: 'multiple',
                value: [10],
                overwrite: false,
            },
        ],
        de: [
            {
                id: '9690',
                type: 'multiple',
                value: [10],
                overwrite: false,
            },
        ],
        fr: [
            {
                id: '9690',
                type: 'multiple',
                value: [10],
                overwrite: false,
            },
        ],
        it: [
            {
                id: '9690',
                type: 'multiple',
                value: [10],
                overwrite: false,
            },
        ],
        es: [
            {
                id: '9690',
                type: 'multiple',
                value: [10],
                overwrite: false,
            },
        ],
        kr: [
            {
                id: '4432',
                type: 'single',
                value: 1,
                overwrite: true,
            },
            {
                id: '31',
                type: 'single',
                value: 1,
                overwrite: true,
            },
            {
                id: '9120',
                type: 'multiple',
                value: [7],
                overwrite: true,
            },
        ],
    };

    const handleSubmit = async () => {
        const emailRegex = /^[\w.-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        if (!emailRegex.test(input)) {
            return setMsg(t('A_input_error'));
        }
        if (!check) {
            return setMsg(t('A_check_tip'));
        }
        // 订阅SMS
        const dataSMS = {
            email: input.trim(),
            contactListId: CONTACT_LIST_ID_MAP[locale],
            fields: FIELDS_MAP[locale],
        };
        try {
            const res = await subscribeShopify(dataSMS, locale, {
                sector_name:
                    locale === 'au' && AU_ENTER_LAUNCH_FLAG
                        ? t('A_title2')
                        : t.rich('A_title', {
                              n: (text: string) => text,
                          }) || 'EcoFlow On-the-Road Power Solution',
                entry_position: 1,
            });
            if (res?.code === '0') {
                setInput('');
                setMsg(t('A_input_success'));
                setTimeout(() => {
                    setMsg('');
                }, 3000);
                gtm.push({
                    event: 'uaEvent',
                    event_name: 'activity_submit',
                    button_name: t('A_btn'),
                    status: 'success',
                    tag: 'Agree',
                });
            } else {
                setMsg(res?.message);
                gtm.push({
                    event: 'uaEvent',
                    event_name: 'activity_submit',
                    button_name: t('A_btn'),
                    status: 'fail',
                    tag: 'Agree',
                });
            }
        } catch (e) {
            setMsg(e);
            gtm.push({
                event: 'uaEvent',
                event_name: 'activity_submit',
                button_name: t('A_btn'),
                status: 'fail',
                tag: 'Agree',
            });
        }
    };

    const termsOfUse: any = {
        us: 'https://us.ecoflow.com/pages/terms-of-use',
        ca: 'https://ca.ecoflow.com/pages/terms-of-use',
        au: 'https://account.ecoflow.com/agreement/en-au/TermsOfUse.html',
        eu: 'https://eu.ecoflow.com/policies/terms-of-service',
        uk: 'https://uk.ecoflow.com/policies/terms-of-service',
        de: 'https://de.ecoflow.com/policies/terms-of-service',
        fr: 'https://fr.ecoflow.com/policies/terms-of-service',
        it: 'https://it.ecoflow.com/policies/terms-of-service',
        es: 'https://es.ecoflow.com/policies/terms-of-service',
        kr: 'https://kr.ecoflow.com/policies/terms-of-service',
    };
    const privacyPolicy: any = {
        us: 'https://account.ecoflow.com/agreement/en-us/PrivacyPolicy.html',
        ca: 'https://account.ecoflow.com/agreement/en-ca/PrivacyPolicy.html',
        au: 'https://au.ecoflow.com/policies/privacy-policy',
        eu: 'https://eu.ecoflow.com/policies/privacy-policy',
        uk: 'https://uk.ecoflow.com/policies/privacy-policy',
        de: 'https://de.ecoflow.com/policies/privacy-policy',
        fr: 'https://fr.ecoflow.com/policies/privacy-policy',
        it: 'https://it.ecoflow.com/policies/privacy-policy',
        es: 'https://es.ecoflow.com/policies/privacy-policy',
        kr: 'https://kr.ecoflow.com/policies/privacy-policy',
    };

    const IS_US_PERIOD = locale === 'us' && nowTime >= US_ACTIVITY_PERIOD.start && nowTime < US_ACTIVITY_PERIOD.end;

    const imgObj = {
        pc: EU_SITES?.includes(locale) ? IMG_MAP['eu']?.pc : IS_US_PERIOD ? IMG_MAP[locale].pc_1 : IMG_MAP[locale]?.pc || IMG_MAP.us.pc,
        h5: EU_SITES?.includes(locale) ? IMG_MAP['eu']?.h5 : IS_US_PERIOD ? IMG_MAP[locale].pc_1 : IMG_MAP[locale]?.h5 || IMG_MAP.us.h5,
    };

    return (
        <div id="RV-A" className={`RV-A ${css['RV-A']}`}>
            <div className="banner-img">
                <EFPicture src={imgObj.pc} srcPad={imgObj.h5 || imgObj.pc} srcMobile={imgObj.h5 || imgObj.pc} alt={t('A_title')} />
            </div>
            <div className={`info-box ${IS_US_PERIOD ? 'period' : ''}`}>
                {!AU_ENTER_LAUNCH_FLAG && <p className="subtitle">{t('A_subtitle')}</p>}
                <p className="big-title">
                    {locale === 'au' && AU_ENTER_LAUNCH_FLAG
                        ? t('A_title2')
                        : t.rich('A_title', {
                              n: (text: string) => <span className="no-wrap">{text}</span>,
                          })}
                </p>
                {locale === 'au' && AU_ENTER_LAUNCH_FLAG && <p className="desc">{t('A_desc')}</p>}
                {(locale === 'us' || locale === 'ca') && <p className="desc">{t('A_desc')}</p>}
                {locale !== 'za' && (
                    <>
                        {(locale !== 'au' || !AU_ENTER_LAUNCH_FLAG) && (
                            <div className="control">
                                <input
                                    type="text"
                                    placeholder={t('A_placeholder')}
                                    className="input"
                                    value={input}
                                    onChange={handleInputChange}
                                    onFocus={handleFocus}
                                />
                                <button className="btn" onClick={handleSubmit}>
                                    {t('A_btn')}
                                </button>
                            </div>
                        )}
                        {msg && <p className={`msg ${msg === t('A_input_success') ? 'success' : ''}`}>{msg}</p>}
                        {(locale !== 'au' || !AU_ENTER_LAUNCH_FLAG) && (
                            <p className="terms">
                                <input id="term-check" type="checkbox" className="check" checked={check} onChange={handleCheck} />
                                <label htmlFor="#term-check" className="terms-text">
                                    {t.rich('A_terms', {
                                        a1: (text: string) => (
                                            <a href={termsOfUse[locale] || termsOfUse.us} className="link" target="_blank" rel="noreferrer">
                                                {text}
                                            </a>
                                        ),
                                        a2: (text: string) => (
                                            <a href={privacyPolicy[locale] || privacyPolicy.us} className="link" target="_blank" rel="noreferrer">
                                                {text}
                                            </a>
                                        ),
                                    })}
                                </label>
                            </p>
                        )}
                    </>
                )}
            </div>
            <style global jsx>
                {`
                    .glo-bar-left-box {
                        bottom: 132px;
                        @media (max-width: 1024px) {
                            bottom: 80px;
                        }
                    }
                `}
            </style>
        </div>
    );
}
